<template>
  <q-dialog v-model="confirm" persistent>
    <q-card style="min-width: 400px; max-width: 750px">
      <q-card-section class="column items-center">
        <q-avatar icon="question_mark" color="primary" text-color="white" />
        <span class="q-ml-sm mensagem-text">{{ mensagem }}</span>
      </q-card-section>

      <q-card-section>
        <slot></slot>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn
          flat
          label="Cancelar"
          color="negative"
          v-close-popup
          @click="$emit('resultado', false)"
        />
        <q-btn
          flat
          label="Confirmar"
          :disabled="desabilitarConfirme"
          color="positive"
          v-close-popup
          @click="$emit('resultado', true)"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { watch, ref } from "vue";
export default {
  props: ["mensagem", "exibir", "desabilitarConfirme"],
  setup(props) {
    const confirm = ref(false);

    watch(
      () => props.exibir,
      () => {
        confirm.value = props.exibir;
      }
    );
    return {
      confirm,
    };
  },
};
</script>

<style scoped>
.mensagem-text {
  font-weight: bold;
  font-size: 18px;
}
</style>
